export default "__VITE_PUBLIC_ASSET__84eee500__"